/**
 * Super class of all geometries
 */
define("tmds/geometry/Geometry", [], function() {
	"use strict";
	
	var Geometry = function() {};
	
	/**
	 * convert Geometry object to JSON representation
	 */
	function toJson() {
		return {
			type: this.type
		};
	}
	
	Geometry.prototype = {
		declaredClass: "tmds.geometry.Geometry",
		type: "Geometry",
		'toJson' : toJson
	};
	
	return Geometry;
});